var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"center"},[_vm._v(_vm._s(_vm.datas.articleTitle))]),_vm._v(" "),_c('p',{staticClass:"justify-end"},[_vm._v("\n      "+_vm._s(_vm.datas.createTime)+"\n    ")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.datas.articleContent)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58dd5e27","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/messageDetail.vue
// module id = null
// module chunks = 